module.exports = "/pages/business/foodslabo/fv_model_sp.png";